import {vacancyConst} from "../constants/vacancies";


export const vacancies = (state = [], action) => {
    switch (action.type) {
        case vacancyConst.CHANGE_MARKED_EMOTION:
            let new_state = [...state];
            let emotion = state[action.index].emotions.find(emotion => emotion.type === action.emotion);
            let index_emotion = state[action.index].emotions.indexOf(emotion);

            new_state[action.index].emotions.splice(index_emotion, 1,
                {
                    ...emotion,
                    isMarked: !emotion.isMarked,
                    count: emotion.isMarked ? emotion.count - 1 : emotion.count + 1,
                });
            return [...new_state];

        case vacancyConst.ADD_VACANCY:
            return [...state, {...action.vacancy, emotions: [], comments: []}];

        case vacancyConst.DELETE_VACANCY:
            let copy_state = [...state];
            copy_state.splice(action.index, 1);
            return [...copy_state];

        case vacancyConst.CHANGE_VACANCY:
            let change_state = [...state];
            change_state.splice(action.index, 1, {
                ...change_state[action.index], info: action.vacancy.info, info_en: action.vacancy.info_en

            });
            return [...change_state];


        case vacancyConst.UPDATE_VACANCIES:
            return [...action.vacancies];
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// src/reducers/vacancies.jsx